import React, { Fragment, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { FormattedNumber, formattedNumber } from "../../FormattedNumber/FormattedNumber";
import { CircularProgress } from "../../UI/CircularProgress/CircularProgress";
import moment from "moment";
import { showToast } from "../../../utils/helper";
import ReactEcharts from "echarts-for-react";
import { getCurrentAccount, getTexts } from "../../../reducers/selectors";
import { getFutureIncome } from "../../../services/api/accounts";
import { Row, Col } from "../../UI/Customstrap/Customstrap";
import { TitleLabel } from "../../UI/TitleLabel/TitleLabel";
import { RadioButton, RadioButtonGroup } from "../../UI/RadioButton/RadioButton";
import GenericButton from "../../UI/Button/Button";
import { fetchGetPortfolio, getClientPositionDigital } from "../../../services/api/accounts";
import confirmIcon from "../../../../public/svg/ButtonIcons/right-arrow.svg";
import { Table, Label } from "reactstrap";

import style from "./FutureIncomeComponent.scss";
import { Warning } from "../../Warning/Warning";
import { Container } from "../../UI/Container/Container";
import { Future } from "bx-react-ui/src/components/Modal/Order/Form";
import FutureButton from "../../UI/Button/FutureButton";

const allowedCurrencies = {
  ALL: "ALL",
  PYG: "PYG",
  USD: "USD",
};

const FutureIncomeComponent = ({ title }) => {
  const [currentFilter, setCurrentFilter] = useState("month");
  const [loading, setLoading] = useState(true);
  const [tableFilter, setTableFilter] = useState({
    desde: moment().valueOf(),
    hasta: moment().add(1, "months").valueOf(),
  });
  const [toggleButton, setToggleButton] = useState(false);
  const [futureIncome, setFutureIncome] = useState([]);
  const currentAccount = useSelector(getCurrentAccount);
  const texts = useSelector(getTexts);
  const [currency, setCurrency] = useState("USD");
  const [activeCurrency, setActiveCurrency] = useState(allowedCurrencies.ALL);
  const [portfolioDate, setPortfolioDate] = useState(new Date().toISOString().slice(0, 10));
  const [portfolio, setPortfolio] = useState(null);
  const [loadingPosition, setLoadingPosition] = useState(true);
  const [activePortfolio, setActivePortfolio] = useState(null);
  const [estimatedTotalReturn, setEstimatedTotalReturn] = useState();

  const handleChangeFilter = (filterType) => {
    const newFilter = {
      desde: moment().valueOf(),
    };

    switch (filterType) {
      case "month":
        newFilter.hasta = moment().add(1, "month").valueOf();
        break;
      case "threeMonth":
        newFilter.hasta = moment().add(3, "month").valueOf();
        break;
      case "sixMonth":
        newFilter.hasta = moment().add(6, "month").valueOf();
        break;
      case "year":
        newFilter.hasta = moment().add(1, "year").valueOf();
        break;
    }

    setTableFilter(newFilter);
  };

  const toggleModal = (type, doUpdateDeposits = false) => {
    setIOModal((prevState) => {
      return {
        open: !prevState.open,
        type,
      };
    });
    if (doUpdateDeposits) updateDeposits();
  };

  const toggleFilterType = (filterType) => {
    setCurrentFilter(filterType);
  };

  const FilterButton = ({ label, active, onClick }) => (
    <div className={`${style.button} ${active ? style.activeButton : ""}`} onClick={onClick}>
      {label}
    </div>
  );

  const handleActiveCurrency = (name) => {
    setActiveCurrency(allowedCurrencies[name]);
  };

  useEffect(() => {
    handleChangeFilter(currentFilter);
  }, [currentFilter]);

  useEffect(() => {
    let estimatedTotal = 0;
    setLoading(() => true);
    if (currentAccount.AccountNumber) {
      getFutureIncome({
        cuenta: currentAccount.AccountNumber,
        from: tableFilter.desde,
        to: tableFilter.hasta,
      })
        .then(({ response }) => {
          const newFutureIncome = response.cashFlow.filter((item) =>
            activeCurrency === "ALL" ? true : item.currencyISO === activeCurrency
          );
          setFutureIncome(newFutureIncome);
          newFutureIncome.map((iterator) => {
            estimatedTotal += activeCurrency === "PYG" ? +iterator.total : +iterator.totalUSD;
          });
          setEstimatedTotalReturn(estimatedTotal);
        })
        .catch((err) => {
          console.error(err);
          showToast("Error obteniendo ingresos futuros", true);
        })
        .finally(() => setLoading(() => false));
    }
  }, [currentAccount, tableFilter, activeCurrency]);

  useEffect(() => {
    if (!loadingPosition) setLoadingPosition(() => true);
    if (currentAccount.AccountNumber) {
      fetchGetPortfolio(currentAccount.AccountNumber, portfolioDate)
        .then(({ response }) => {
          setPortfolio(response);
        })
        .catch((err) => console.error(err));
      setLoadingPosition(false);
    }
    if (currentAccount.noAccounts) {
      setLoadingPosition(false);
    }
  }, [currentAccount, portfolioDate]);

  //if (!loadingPosition) return <CircularProgress/>;

  useEffect(() => {
    if (portfolio && !loadingPosition) {
      let newActivePortfolio;
      switch (activeCurrency) {
        case allowedCurrencies.ALL:
          newActivePortfolio = portfolio.positionUSD;
          break;
        case allowedCurrencies.PYG:
          newActivePortfolio = portfolio.positionPYG;
          break;
        case allowedCurrencies.USD:
          newActivePortfolio = portfolio.position;
          break;
      }

      newActivePortfolio.assetClass = newActivePortfolio.assetClass.map((assetClass) => {
        assetClass.percentage =
          Math.round(((+assetClass.totalUSD * 100) / +newActivePortfolio.portfolioTotalUSD) * 100) / 100;
        return assetClass;
      });
      newActivePortfolio.assetClass = newActivePortfolio.assetClass.sort((a, b) => {
        return a.percentage < b.percentage ? 1 : -1;
      });
      // if (newActivePortfolio && newActivePortfolio.assetClass) {
      // } else {
      //   return (newActivePortfolio = "20%");
      // }

      const subAssetClasses = [];
      newActivePortfolio.assetClass.map((assetClass) => {
        assetClass.subAssetClass.map((subAssetClassItem) => {
          subAssetClasses.push(subAssetClassItem);
        });
      });

      newActivePortfolio.subAssetClasses = subAssetClasses;
      setActivePortfolio(newActivePortfolio);
    }
  }, [activeCurrency, portfolio, loadingPosition]);

  return (
    <Row>
      <Col xs={12} xl={12}>
        <Row>
          <Col xs={12}>
            <Row className={style.headerTitle}>
              <Label>{title}</Label>
            </Row>
            <Container >
              <Row className={style.rowBeginning}>
                <Col>
                  <RadioButtonGroup>
                    <RadioButton
                      label="Todos"
                      onClick={handleActiveCurrency}
                      name={allowedCurrencies.ALL}
                      active={activeCurrency === allowedCurrencies.ALL}
                    />
                    <RadioButton
                      label="Guaraníes"
                      onClick={handleActiveCurrency}
                      name={allowedCurrencies.PYG}
                      active={activeCurrency === allowedCurrencies.PYG}
                    />
                    <RadioButton
                      label="Dólares"
                      onClick={handleActiveCurrency}
                      name={allowedCurrencies.USD}
                      active={activeCurrency === allowedCurrencies.USD}
                    />
                  </RadioButtonGroup>
                </Col>
                <Col className={style.colCambioActual} xs={3}>
                  {portfolio && portfolio.currencypairprice && (
                    <div className={style.fx}>
                      <span className={style.fxLabel}>Cambio actual:</span>
                      <span>{`Gs ${formattedNumber(portfolio.currencypairprice.rawprice, 0, 0)}`}</span>
                    </div>
                  )}
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <Col xs={12}>
              <Container className={style.container}>
                <Row className={style.containerRow}>
                  <Col xs={3} className={style.tableMargin}>
                    <FutureButton
                      label="1 mes"
                      style
                      active={currentFilter === "month"}
                      labelStyle={{ fontSize: "21px", fontWeight: "470", color: "#79716B" }}
                      handleClick={() => {
                        toggleFilterType("month");
                      }}
                      iconSvg={[{ width: "10px", item: confirmIcon }]}
                    />

                    <FutureButton
                      label="3 meses"
                      style
                      active={currentFilter === "threeMonth"}
                      labelStyle={{ fontSize: "20px", fontWeight: "470", color: "#79716B" }}
                      handleClick={() => {
                        toggleFilterType("threeMonth");
                      }}
                      iconSvg={[{ width: "10px", item: confirmIcon }]}
                    />
                    <FutureButton
                      label="6 meses"
                      style
                      active={currentFilter === "sixMonth"}
                      labelStyle={{ fontSize: "20px", fontWeight: "470", color: "#79716B" }}
                      handleClick={() => {
                        toggleFilterType("sixMonth");
                      }}
                      iconSvg={[{ width: "10px", item: confirmIcon }]}
                    />
                    <FutureButton
                      label="12 meses"
                      style
                      active={currentFilter === "year"}
                      labelStyle={{ fontSize: "20px", fontWeight: "470", color: "#79716B" }}
                      handleClick={() => {
                        toggleFilterType("year");
                      }}
                      iconSvg={[{ width: "10px", item: confirmIcon }]}
                    />
                  </Col>
                  <Col xs={9} className={style.tableMargin}>
                    <div className={style.divChartWrapper}>
                      <Row className={style.chartRow}>
                        <Col className={style.chartRowSub} xs={8}>
                          {!loading && <Chart items={futureIncome} />}
                        </Col>
                        <Col className={style.ColumnLineStyleFutureIncome} xs={4}>
                          <Row>
                            <TitleLabel className={style.expectedIncomeTitle} label="Ingreso esperado" />
                          </Row>
                          <Row>
                            {
                              <div className={style.expectedIncomeValueAlign}>
                                {
                                  <div className={style.expectedIncomeValue}>
                                    <FormattedNumber
                                      value={estimatedTotalReturn}
                                      minimumFractionDigits={activeCurrency == "PYG" ? 0 : 2}
                                      maximumFractionDigits={activeCurrency == "PYG" ? 0 : 2}
                                    />
                                  </div>
                                }
                                {
                                  <div className={style.expectedIncomeValueISO}>
                                    {activeCurrency === "PYG" ? "PYG" : "USD"}
                                  </div>
                                }
                              </div>
                            }
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <div className={style.tableTitle}>Próximos movimientos</div>
                  <div className={style.scrollableTable}>
                    <Table className={style.table}>
                      <thead className={style.tableHead}>
                        <tr className={style.tableRow}>
                          <th className={style.tableH}>Fecha</th>
                          <th className={`${style.tableH} ${style.sm}`} style={{ textAlign: "center" }}>
                            Tipo
                          </th>
                          <th className={style.tableH}>Instrumento</th>
                          <th className={style.tableH}>{`Monto ${
                            activeCurrency === "PYG" ? "Gs" : "USD"
                          }`}</th>
                          <th className={`${style.tableH} ${style.md} ${style.sm}`}>{`Monto acumulado ${
                            activeCurrency === "PYG" ? "Gs" : "USD"
                          }`}</th>
                        </tr>
                      </thead>
                      <tbody className={style.tableBody}>
                        {currentAccount.noAccounts ? (
                          <NoAccounts />
                        ) : loading ? (
                          <tr>
                            <td colSpan={5} className={style.circularProgressRow}>
                              <CircularProgress />
                            </td>
                          </tr>
                        ) : futureIncome.length > 0 ? (
                          futureIncome.map((item) => (
                            <FutureIncomeRow item={item} currency={activeCurrency} />
                          ))
                        ) : (
                          <tr className={style.futureIncomeRow}>
                            <td colSpan={5} style={{ textAlign: "center" }}>
                              No hay futuros ingresos para los filtros seleccionados
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </Row>
              </Container>
            </Col>
          </Col>
        </Row>
      </Col>
    </Row>

    // <Row>
    //   <Col className={style.wrapperCol} lg="12">
    //     <Row className={style.buttonRow}>
    // <FilterButton
    //   label="1 mes"
    //   active={currentFilter === "month"}
    //   onClick={() => {
    //     toggleFilterType("month");
    //   }}
    // />
    //       <FilterButton
    //         label="2 meses"
    //         active={currentFilter === "twoMonth"}
    //         onClick={() => {
    //           toggleFilterType("twoMonth");
    //         }}
    //       />
    //       <FilterButton
    //         label="6 meses"
    //         active={currentFilter === "sixMonth"}
    //         onClick={() => {
    //           toggleFilterType("sixMonth");
    //         }}
    //       />
    //       <FilterButton
    //         label="1 año"
    //         active={currentFilter === "year"}
    //         onClick={() => {
    //           toggleFilterType("year");
    //         }}
    //       />
    //     </Row>
    //     <Row className={style.tableRow}>
    //       <span className={style.toggleButtonRow}>
    //         <Button
    //           className={`${style.toggleButton} ${currency === "PYG" ? style.toggleButtonActive : ""}`}
    //           onClick={() => {
    //             setCurrency("PYG");
    //           }}
    //         >
    //           Guaraníes
    //         </Button>
    //         <Button
    //           className={`${style.toggleButton} ${currency === "USD" ? style.toggleButtonActive : ""}`}
    //           onClick={() => {
    //             setCurrency("USD");
    //           }}
    //         >
    //           Dólares
    //         </Button>
    //       </span>
    // <Fragment>
    //   <Table className={style.table}>
    //     <thead className={style.tableHead}>
    //       <tr className={style.tableRow}>
    //         <th className={style.tableH}>Fecha</th>
    //         <th className={`${style.tableH} ${style.sm}`} style={{ textAlign: "center" }}>
    //           Concepto
    //         </th>
    //         <th className={style.tableH}>Instrumento</th>
    //         <th className={style.tableH}>{`Monto ${currency === "PYG" ? "Gs" : "USD"}`}</th>
    //         <th className={`${style.tableH} ${style.md} ${style.sm}`}>{`Monto acumulado ${
    //           currency === "PYG" ? "Gs" : "USD"
    //         }`}</th>
    //       </tr>
    //     </thead>
    //     <tbody className={style.tableBody}>
    //       {currentAccount.noAccounts ? (
    //         <NoAccounts />
    //       ) : loading ? (
    //         <tr>
    //           <td colSpan={5} className={style.circularProgressRow}>
    //             <CircularProgress />
    //           </td>
    //         </tr>
    //       ) : futureIncome.length > 0 ? (
    //         futureIncome.map((item) => <FutureIncomeRow item={item} currency={currency} />)
    //       ) : (
    //         <tr className={style.futureIncomeRow}>
    //           <td colSpan={5} style={{ textAlign: "center" }}>
    //             No hay futuros ingresos para los filtros seleccionados
    //           </td>
    //         </tr>
    //       )}
    //     </tbody>
    //   </Table>
    // </Fragment>
    //     </Row>
    // <Row>
    //   <Col>{!loading && <Chart items={futureIncome} />}</Col>
    // </Row>
    //     <Row className={style.warning}>
    //       <Warning text={texts.notes.future_note} />
    //     </Row>
    //   </Col>
    // </Row>
  );
};

const NoAccounts = () => (
  <tr className={style.futureIncomeRow}>
    <td colSpan={5}>No hay cuentas asociadas</td>
  </tr>
);

const conceptDictionary = (concept) => {
  let res = "-";
  if (concept === 0) return res;
  concept.toLowerCase() === "maturity" ? (res = "Vencimiento") : null;
  concept.toLowerCase() === "sync" ? (res = "Amortización") : null;
  concept.toLowerCase() === "capitalization" ? (res = "Capitalización") : null;
  concept.toLowerCase() === "dividend" ? (res = "Dividendo") : null;
  concept.toLowerCase() === "coupon" ? (res = "Cupón") : null;
  return res;
};

const FutureIncomeRow = ({ item, currency }) => {
  return (
    <tr className={style.futureIncomeRow}>
      <td>{moment(item.date).format("DD/MM/YYYY")}</td>
      <td className={`${style.tableH} ${style.sm}`} style={{ textAlign: "center" }}>
        {conceptDictionary(item.concept)}
      </td>
      <td>{item.assetName}</td>
      <td>
        {item.total == 0 ? (
          "-"
        ) : (
          <FormattedNumber
            value={currency == "USD" || currency == "ALL" ? item.totalUSD : item.total}
            minimumFractionDigits={currency == "USD" || currency == "ALL" ? 2 : 0}
            maximumFractionDigits={currency == "USD" || currency == "ALL" ? 2 : 0}
          />
        )}
      </td>
      <td className={`${style.tableH} ${style.md} ${style.sm}`}>
        {item.totalUSDAccumulated == 0 ? (
          "-"
        ) : (
          <FormattedNumber
            value={currency == "USD" || currency == "ALL" ? item.totalUSDAccumulated : item.totalAccumulated}
            minimumFractionDigits={currency == "USD" || currency == "ALL" ? 2 : 0}
            maximumFractionDigits={currency == "USD" || currency == "ALL" ? 2 : 0}
          />
        )}
      </td>
    </tr>
  );
};

const Chart = ({ items }) => {
  const [data, setData] = useState(false);

  useEffect(() => {
    if (items) {
      let values = [];
      let labels = [];

      items.forEach((item) => {
        values.push(+item.total);
        labels.push(item.date);
      });
      setData({ values, labels });
    } else {
      setData(false);
    }
  }, [items]);

  return (
    <div className={style.chartWrapper}>
      {data && (
        <ReactEcharts
          option={options(data)}
          notMerge={true}
          lazyUpdate={false}
          style={{
            height: "100%",
            width: "92%",
          }}
        />
      )}
    </div>
  );
};

const options = ({ values, labels }) => ({
  color: ["#27272A"],
  grid: {
    top: 20,
    bottom: 30,
    left: 60,
    right: 40,
  },
  tooltip: {
    trigger: "axis",
    formatter: function (params) {
      return formattedNumber(params[0].value);
    },
  },
  xAxis: [
    {
      type: "category",
      data: labels,
    },
  ],
  yAxis: [
    {
      type: "value",
      boundaryGap: [0, "100%"],
      splitLine: {
        show: true,
      },
      axisLabel: {
        formatter: function (params) {
          if (params.toString().length > 6) {
            return parseFloat((params / 1e6).toFixed(2)) + " M";
          } else return formattedNumber(params);
        },
      },
    },
  ],

  series: [
    {
      type: "bar",
      showSymbol: true,
      barWidth: "90%",
      hoverAnimation: true,
      data: values,
      height: "100%",
      itemStyle: {
        borderRadius: [5, 5, 0, 0],
      },
    },
  ],
});

export default FutureIncomeComponent;
